import { HpClientStandardInputTextAndStyle } from '../../../types';
import { HpInputControlProps } from '../../../types/inputControlTypes';
import { StandardFormGroupWidget } from '../../widgets/standardFormGroupWidget';
import { BasicReadOnlyTextControl } from '../common/readOnlyTextControl';

export function ReadOnlyTextControl({
  answerSource,
  data,
  dataType,
  formatType,
  id,
  onChange,
  question,
  questionText,
  subtext,
  ui,
  value
}: HpInputControlProps): JSX.Element {
  const textAndStyle = data.textAndStyle[formatType] as HpClientStandardInputTextAndStyle;
  const control = <BasicReadOnlyTextControl id={id} value={value} />;
  return (
    <StandardFormGroupWidget
      answerSource={answerSource}
      control={control}
      controlType="read-only-text"
      dataType={dataType}
      error={undefined}
      helpInfo={data.helpInfo}
      helpInfoUI={ui.helpInfo}
      id={id}
      onClick={onChange}
      question={question}
      questionText={questionText}
      subtext={subtext}
      textAndStyle={textAndStyle}
    />
  );
}
